import Component from "@tunnel-components/@sharded/pathSVG/component";
import {
  MaskZoneLoadedActionCreator,
  GetZoneByIdCameraResetActionCreator,
} from "@tunnel-store/index";
import { connect } from "react-redux";

import * as React from "react";
import * as Lodash from "lodash";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name onGetXYPosition
 * @name onGetMouseCoord
 * @name onGetMouseOverCoord
 * @name PathSVGElement
 * @name onPolygonCreated
 * @name componentWillUnmount
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://reactjs.org"
 */

class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @property { object }     state
     * @property { array }      state.all_points_x
     * @property { array }      state.all_points_y
     * @property { array }      state.coordsDS
     * @property { array }      state.morePath
     * @property { array }      state.mouse_over_x
     * @property { array }      state.mouse_over_y
     * @property { atring }     state.xyCoord
     * @property { array }      state.xySVGCircle
     */
    this.state = {
      all_points_x: [],
      all_points_y: [],
      coordsDS: [],
      morePath: [],
      mouse_over_x: [],
      mouse_over_y: [],
      xyCoord: "",
      xySVGCircle: [],
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque
     * initialisation des composants "seulement quand il y'a un event
     * exécuté"
     */
    this.onGetMouseCoord = this.onGetMouseCoord.bind(this);
    this.onGetMouseOverCoord = this.onGetMouseOverCoord.bind(this);
    this.onPolygonCreated = this.onPolygonCreated.bind(this);
    this.PathSVGElement = this.PathSVGElement.bind(this);
  }
  /**
   * Recupère la position X et Y de la souris
   * Sur l'écran
   * @method onGetXYPosition
   * @param { any }  event
   * @return { object }
   * @infos "https://cyclope.ai"
   */
  public onGetXYPosition = (event: any): any => {
    let xCoord: any = ""; // get x coordonnates
    let yCoord: any = ""; // get y coordonnates;
    let xyCoord: string = ""; // get last mouse position;

    let xySVGCircle: any = {};

    if (event.pageX || event.pageY) {
      xCoord = Math.ceil(event.pageX);
      yCoord = Math.ceil(event.pageY);
    } else {
      xCoord = Math.ceil(event.clientX); // get x coordonnates
      yCoord = Math.ceil(event.clientY); // get y coordonnates
    }

    xCoord -= Math.ceil(event.currentTarget.getBoundingClientRect().left);
    yCoord -= Math.ceil(event.currentTarget.getBoundingClientRect().top);

    xyCoord = Math.ceil(xCoord)
      .toString()
      .concat(" ", Math.ceil(yCoord).toString()); // get last position

    xySVGCircle = { xCoord, yCoord };

    return {
      xCoord,
      xyCoord,
      xySVGCircle,
      yCoord,
    };
  };
  /**
   * Recupère la position X et Y de la souris
   * Sur l'écran
   * @method onGetMouseCoord
   * @param { any }  event
   * @infos "https://cyclope.ai"
   */
  public onGetMouseCoord = (event: any) => {
    /*
     * Find x and y coordonnate
     */
    const xyPosition = this.onGetXYPosition(event);

    const all_points_x: any[] = this.state.all_points_x;
    const all_points_y: any[] = this.state.all_points_y;

    const xySVGCircle: any[] = this.state.xySVGCircle;

    if (this.props.drawZone) {
      if (!Lodash.isUndefined(xySVGCircle)) {
        xySVGCircle.push(xyPosition.xySVGCircle);
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({
          xySVGCircle,
        }));
      }
      if (
        !Lodash.isUndefined(xyPosition.xCoord) &&
        !Lodash.isUndefined(xyPosition.yCoord)
      ) {
        all_points_x.push(Math.ceil(xyPosition.xCoord)); // push x coordonnate
        all_points_y.push(Math.ceil(xyPosition.yCoord)); // push y coordonnate
      }

      const xyCoord: any = xyPosition.xyCoord;

      this.props.coords(all_points_x, all_points_y); // send coordonnate to Ds
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ all_points_x, all_points_y, xyCoord })); // upadate state value
    }
  };

  /**
   * Recupère la position X et Y de la souris
   * Sur l'écran
   * @method onGetMouseOverCoord
   * @param { any }  event
   * @return { object }
   * @infos "https://cyclope.ai"
   */
  public onGetMouseOverCoord = (event: any) => {
    /*
     * Find x and y coordonnate
     */
    const xyPosition = this.onGetXYPosition(event);

    if (this.props.drawZone) {
      let mouse_over_x: any = this.state.mouse_over_x;
      let mouse_over_y: any = this.state.mouse_over_y;

      if (
        !Lodash.isUndefined(xyPosition.xCoord) &&
        !Lodash.isUndefined(xyPosition.yCoord)
      ) {
        mouse_over_x = Math.ceil(xyPosition.xCoord); // push x coordonnate
        mouse_over_y = Math.ceil(xyPosition.yCoord); // push y coordonnate
      }
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ mouse_over_x, mouse_over_y })); // upadate state value

      this.props.coordMouseOver(mouse_over_x, mouse_over_y, this.state.xyCoord); //
    }
  };
  /**
   * Double click :  cette methode permet d'arrêter
   * l'enregistrement des coordonnés de la souris
   * @method PathSVGElement
   * @param {  }
   * @infos "https://cyclope.ai"
   */
  public PathSVGElement = () => {
    const PathSVGElement: any = document.getElementById("PathSVGElement");

    if (!Lodash.isNull(PathSVGElement)) {
      PathSVGElement.addEventListener("dblclick", () =>
        this.onPolygonCreated()
      );
    }
  };
  /**
   * Dessine un polygonne sur l'écran
   * @method onPolygonCreated
   * @param {  }
   * @infos "https://cyclope.ai"
   */
  public onPolygonCreated = () => {
    const morePath: string[] = this.state.morePath;
    const coordsDS: any[] = this.state.coordsDS;

    if (this.props.drawZone) {
      morePath.push(this.props.coordString);
      coordsDS.push(this.props.coordsDS);

      this.props.handleToUpdate(coordsDS);
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({
        all_points_x: [],
        all_points_y: [],
        coordString: "",
        coordStringMouseOver: "",
        coordsDS,
        morePath,
        xyCoord: "",
      }));

      this.props.virtualDomUpdate();
    }
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      all_points_x: [],
      all_points_y: [],
      coordString: "",
      coordStringMouseOver: "",
      coordsDS: [],
      morePath: [],
      xySVGCircle: [],
    }));

    this.props.GetZoneByIdCameraResetActionCreator();
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    if (
      nextProps.camera !== this.props.camera ||
      nextProps.zone !== this.props.zone
    ) {
      this.props
        .GetZoneByIdCameraResetActionCreator()
        .then(() =>
          this.props.MaskZoneLoadedActionCreator(
            nextProps.camera,
            nextProps.zone
          )
        );
    } else if (nextProps.target !== this.props.target) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ target: nextProps.target }));
    } else if (nextProps.coordString !== this.props.coordString) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ coordString: nextProps.coordString }));
    } else if (
      nextProps.coordStringMouseOver !== this.props.coordStringMouseOver
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({
        coordStringMouseOver: nextProps.coordStringMouseOver,
      }));
    } else if (nextProps.withdrawPolygon === true) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({
        all_points_x: [],
        all_points_y: [],
        coordString: "",
        coordStringMouseOver: "",
        coordsDS: [],
        morePath: [],
        xySVGCircle: [],
      }));
    } else if (nextProps.source !== this.props.source) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ source: nextProps.source }));
    }
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    this.props
      .GetZoneByIdCameraResetActionCreator()
      .then(() =>
        this.props.MaskZoneLoadedActionCreator(
          this.props.camera,
          this.props.zone
        )
      );
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        PathSVGElement={this.PathSVGElement}
        onPolygonCreated={this.onPolygonCreated}
        onGetMouseOverCoord={this.onGetMouseOverCoord}
        onGetMouseCoord={this.onGetMouseCoord}
        {...this.state}
        {...this.props}
      />
    );
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    error: state.GetZoneByIdCameraLoaded.error,
    source: state.GetZoneByIdCameraLoaded.data,
  };
}
{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, {
  MaskZoneLoadedActionCreator,
  GetZoneByIdCameraResetActionCreator,
})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/pathSVG/container.tsx